import React from 'react';
import { useTranslation } from 'react-i18next';

// assets
import { Communication, Users } from 'icons/untitledui';

// hooks
import useCanAccessConversations from 'eCoach/hooks/useCanAccessConversations';

// styles
import * as TeamOverviewStyles from 'teamLeadInsights/styles/TeamOverview.style';
import * as Text from 'theme/components/Text.style';

interface TeamOverviewProps {
  onboardingRate: number;
  sessionCount: number;
  recentSessionsCount: number;
}

export default function TeamOverview({
  onboardingRate,
  sessionCount,
  recentSessionsCount,
}: TeamOverviewProps): JSX.Element {
  const { t } = useTranslation('pageTeamLeadInsights');
  const canAccessConversations = useCanAccessConversations();

  return (
    <>
      <Text.H5>{t('insights.Across your teams')}</Text.H5>
      <TeamOverviewStyles.TopCard>
        <TeamOverviewStyles.InsightsSection>
          <TeamOverviewStyles.Insight>
            <Text.H3>{onboardingRate}</Text.H3>
            <TeamOverviewStyles.InsightLabel>
              <Users.Users01 />
              <Text.P2Semibold>{t('insights.Onboarded')}</Text.P2Semibold>
            </TeamOverviewStyles.InsightLabel>
          </TeamOverviewStyles.Insight>
          {canAccessConversations && (
            <>
              <TeamOverviewStyles.Insight>
                <Text.H3>{sessionCount}</Text.H3>
                <TeamOverviewStyles.InsightLabel>
                  <Communication.MessageTextSquare02 />
                  <Text.P2Semibold>
                    {t('insights.Total conversations')}
                  </Text.P2Semibold>
                </TeamOverviewStyles.InsightLabel>
              </TeamOverviewStyles.Insight>
              <TeamOverviewStyles.Insight>
                <Text.H3>{recentSessionsCount}</Text.H3>
                <TeamOverviewStyles.InsightLabel>
                  <Communication.MessageTextSquare02 />
                  <Text.P2Semibold>
                    {t('insights.Past 30 days')}
                  </Text.P2Semibold>
                </TeamOverviewStyles.InsightLabel>
              </TeamOverviewStyles.Insight>
            </>
          )}
        </TeamOverviewStyles.InsightsSection>
      </TeamOverviewStyles.TopCard>
    </>
  );
}
